<template>
  <div id="after4" style="margin: auto;"  >
    <!-- <v-switch :label="`Show cards: ${seen.toString()}`" v-model="seen"></v-switch> -->
    <v-container fluid grid-list-xl>
      <transition-group name="fade-transition" tag="v-layout" class="row wrap">
        <v-flex xs12 sm6 lg3 v-for="course in courses" :key="course.id">
          <v-card :color="colors[course.day]" v-if="seen" dark>
            <v-card-title primary-title>
              <div>
                <h3 class="headline mb-0">{{ course.title }}</h3>
                <h4 class="subheading">{{ course.day }}</h4>
                <div>{{ course.desc }}</div>
              </div>
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat @click.native="registerCourse(course, $event)">
                <div v-if="course.registered">
                  <v-icon left>check</v-icon>Registered
                </div>
                <div v-else>
                  <v-icon left>add_circle</v-icon>
                  Register
                </div>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </transition-group>
    </v-container>
  </div>
</template>

<script>
import { HTTP } from "./http-common";

export default {
  data() {
    return {
      colors: {
        Monday: "pink",
        Tuesday: "purple",
        Wednesday: "deep-purple",
        Thursday: "indigo"
      },
      seen: true
    };
  },
  props: ["courses", "selectedChild"],
  methods: {
    registerCourse: function(course, event) {
      var to_post = course
      to_post.registered = !to_post.registered;
      delete to_post.homeroom;
      HTTP.put("courses/" + to_post.id + '?_expand=homeroom', to_post).then(response => {
        console.log(response.data);
      });
    }
  }
};
</script>
